import React, { FormEvent, useState } from "react";
import { useDispatch } from "react-redux";
import { setAdvancedInvestorSearchParams } from "../../../../redux/actions/investors";
import { hideModal } from "../../../../redux/actions/modal";
import { IInvestorSearchParams } from "../../../../interfaces/investor";
import CustomSelectDropdown from "../../../../components/CustomHTMLElements/CustomSelectDropdown";
import useAllAggregatorsTyped from "../../../../custom-hooks/useAllAggregatorsTyped";

interface IProps {
  id: number;
  name: string;
  description: string;
}

const AdvancedInvestorSearchModal = ({
  onCloseModal,
}: {
  onCloseModal: () => void;
}) => {
  const [state, setState] = useState<IInvestorSearchParams>({
    searchValue: "",
    searchBy: 3,
    aggregatorId: "",
    email: "",
  });

  const dispatch = useDispatch();
  const { data: aggregatorData } = useAllAggregatorsTyped();

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>,
  ) => {
    const { name, value } = e.target;
    setState((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    dispatch(setAdvancedInvestorSearchParams(state));
    dispatch(hideModal());
  };

  const handleClear = () => {
    const clearedState: IInvestorSearchParams = {
      searchValue: "",
      searchBy: 3,
      aggregatorId: "",
      email: "",
    };
    setState(clearedState);
    dispatch(setAdvancedInvestorSearchParams(clearedState));
    onCloseModal();
  };

  return (
    <div
      className="Modal__dialog lg-modal animated slideInDown"
      role="document"
    >
      <div className="LoanModal Modal__content">
        <div className="Modal__body" style={{ overflow: "hidden" }}>
          <React.Fragment>
            <h3 className="Modal__title p-b-1">Advanced Search:</h3>
            <div id="investor-search">
              <div className="m-b-30">
                <form onSubmit={handleSubmit}>
                  <div className="row">
                    <div className="col-md-4 col-sm-12 mt-2">
                      <label htmlFor="searchValue">Funder Name:</label>
                      <input
                        type="text"
                        className="form-control"
                        onChange={handleChange}
                        name="searchValue"
                        value={state.searchValue}
                        placeholder="Enter funder name..."
                      />
                    </div>
                    <div className="col-md-4 col-sm-12 mt-2">
                      <label htmlFor="searchBy">Investor Type:</label>
                      <CustomSelectDropdown
                        onChange={handleChange}
                        name="searchBy"
                        value={state.searchBy}
                        isShowDropdownArrow
                      >
                        <option value={3}>All Investors</option>
                        <option value={1}>Individual Investors</option>
                        <option value={2}>Corporate Investors</option>
                      </CustomSelectDropdown>
                    </div>
                    <div className="col-md-4 col-sm-12 mt-2">
                      <label htmlFor="aggregatorId">Aggregator:</label>
                      <CustomSelectDropdown
                        onChange={handleChange}
                        name="aggregatorId"
                        value={state.aggregatorId}
                        isShowDropdownArrow
                      >
                        <option value="">Select Aggregator</option>
                        {aggregatorData &&
                          aggregatorData?.data?.data.map((aggregator) => {
                            const { biz_name, aggregator_id } = aggregator;
                            return (
                              <option
                                value={Number(aggregator_id)}
                                key={aggregator_id}
                              >
                                {biz_name}
                              </option>
                            );
                          })}
                      </CustomSelectDropdown>
                    </div>
                    <div className="col-md-4 col-sm-12 mt-2">
                      <label htmlFor="email">Email:</label>
                      <input
                        type="email"
                        className="form-control"
                        onChange={handleChange}
                        name="email"
                        value={state.email}
                        placeholder="Enter email..."
                      />
                    </div>
                  </div>
                  <div className="Form__action-buttons mt-5">
                    <button
                      type="submit"
                      className="btn zoom-element btn login-btn m-0 mr-auto"
                    >
                      <i className="fa fa-check-circle" /> Search
                    </button>
                    <button
                      type="button"
                      onClick={handleClear}
                      className="btn zoom-element btn login-btn m-0 ml-auto"
                    >
                      <i className="fa fa-times-circle" /> Clear
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </React.Fragment>
        </div>
      </div>
    </div>
  );
};

export default AdvancedInvestorSearchModal;
